var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M34.9951 0C43.2793 0.000149133 49.9951 6.71582 49.9951 15V35C49.9951 43.2842 43.2793 49.9998 34.9951 50H15C6.71573 50 3.22157e-07 43.2843 0 35V15C3.22157e-07 6.71573 6.71573 0 15 0H34.9951Z",
    fill: "#D03639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M32.4948 19.667C34.5656 19.6673 36.2448 21.458 36.2448 23.667C36.2445 25.8757 34.5654 27.6667 32.4948 27.667C30.4238 27.667 28.745 25.8759 28.7448 23.667C28.7448 21.4579 30.4237 19.667 32.4948 19.667ZM21.2477 13C24.009 13 26.2475 15.3876 26.2477 18.333C26.2477 21.2785 24.0091 23.667 21.2477 23.667C18.4864 23.6669 16.2477 21.2785 16.2477 18.333C16.2478 15.3877 18.4865 13.0001 21.2477 13Z",
    fill: "#D03639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2236 26.3335C27.2077 26.3335 32.1238 29.391 32.4902 35.9331C32.5048 36.1937 32.4906 37.0005 31.5517 37.0005H10.9052C10.5918 37.0005 9.96966 36.2788 9.99605 35.9321C10.4806 29.5687 15.3225 26.3335 21.2236 26.3335ZM31.9951 29.0024C36.2534 29.0516 39.7304 31.3462 39.9921 36.1997C40.0027 36.3952 39.9924 37.0004 39.3144 37.0005H34.4931C34.4931 33.9996 33.5634 31.2306 31.9951 29.0024Z",
    fill: "#D03639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAlerts);
export default __webpack_public_path__ + "static/media/CriticalAlerts.f109233e48fa67f107a0c184df61a02a.svg";
export { ForwardRef as ReactComponent };